import type { TypePolicies } from '../../../utils';

export const typePolicies: TypePolicies = {
  Asset: {
    keyFields: ({ id }) => `Asset:${id}`,
    fields: {
      // BE returns an active-only list. Completed jobs disappear silently.
      // So we replace here rather than merge. A job dropping out clears the asset-card spinner.
      assetJobs: {
        merge: false,
      },
    },
  },
  FolderAsset: {
    fields: {
      thumbnails: {
        // we always want the server to replace the list we have cached
        merge: false,
      },
    },
  },
};
